// extracted by mini-css-extract-plugin
export var fullWidth = "_3f-3";
export var linedContainer = "_3f-0";
export var relyOnExternalBottomBorder = "_3f-1";
export var selected = "_3f-4";
export var tab = "_3f-2";